<div
  class="w-full flex flex-col gap-4 md:gap-0 md:flex-row-reverse items-center justify-between"
>
  <div
    class="relative"
    appClickOutside
    (appClickOutside)="isLanguageDropdownOpen.set(false)"
  >
    <app-button
      [text]="'components.languageFilter.addLanguage' | transloco"
      [icon]="'nav-arrow-down'"
      [variant]="'quaternary'"
      (buttonClick)="toggleLanguageDropdown()"
    ></app-button>
    @if(isLanguageDropdownOpen()) {
    <div
      class="absolute top-full right-0 mt-2 w-[15.625rem] bg-white rounded-lg shadow-lg border border-vinciGrey-200 z-10 max-h-[18.75rem] overflow-y-auto"
    >
      <div class="p-2">
        @for(lang of availableLanguages(); track lang) {
        <button
          class="w-full text-left px-4 py-2 hover:bg-vinciBlue-25 rounded transition-colors hover:cursor-pointer"
          [class.bg-vinciBlue-50]="languagesSelected().includes(lang)"
          [class.text-vinciBlue-600]="languagesSelected().includes(lang)"
          [class.font-semibold]="languagesSelected().includes(lang)"
          (click)="handleLanguage(lang)"
        >
          {{ lang }}
        </button>
        }
      </div>
    </div>
    }
  </div>
  @if(languagesSelected().length > 0) {
  <div class="flex flex-col md:flex-row gap-4 items-center">
    <span class="whitespace-nowrap">{{ textToDisplayIfAnySelected() }}</span>
    <div class="flex flex-wrap gap-2 items-center">
      @for(lang of languagesSelected(); track lang) {
      <button
        class="flex items-center gap-2 h-[2.625rem] px-2 rounded-lg bg-vinciBlue-25 border border-vinciBlue-300 text-vinciBlue cursor-pointer hover:bg-vinciBlue-200 transition-colors duration-300"
        (click)="this.removeLanguage(lang)"
      >
        {{lang}}
        <icon
          [name]="'close'"
          [size]="'1rem'"
          [color]="'text-vinciBlue-600'"
        ></icon>
      </button>
      }
    </div>
  </div>
  }
</div>
